import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldIcon, CalendarIcon } from 'lucide-react';
const WISTIA_VIDEO_ID = 'yawb4ycnzl';
export function Hero() {
  const [showVideoCTA, setShowVideoCTA] = useState(false);
  useEffect(() => {
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load Wistia embed module
    const embedScript = document.createElement('script');
    embedScript.src = `https://fast.wistia.com/embed/${WISTIA_VIDEO_ID}.js`;
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Show CTA after 37 seconds on page
    const timer = setTimeout(() => {
      setShowVideoCTA(true);
    }, 37000);
    return () => clearTimeout(timer);
  }, []);
  return <section className="relative pt-20 pb-12 md:pt-40 md:pb-32 bg-navy overflow-hidden" data-id="element-68">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-69"></div>

      <div className="max-w-5xl mx-auto px-4 md:px-12 relative z-10" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center max-w-4xl mx-auto" data-id="element-71">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-light border border-gold/30 text-gold text-xs md:text-sm font-medium mb-5 md:mb-8" data-id="element-72">
            <ShieldIcon size={14} data-id="element-73" />
            <span data-id="element-74">Gestión Patrimonial Privada</span>
          </div>

          <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-8" data-id="element-75">
            El Protocolo del Retiro Blindado:{' '}
            <span className="text-gold" data-id="element-76">
              Cómo garantizar un flujo mensual de por vida (en UDIs)
            </span>{' '}
            sin depender de la AFORE ni del Gobierno.
          </h1>

          <h2 className="text-base md:text-xl text-gray-light leading-relaxed mb-8 md:mb-16 max-w-3xl mx-auto" data-id="element-77">
            La estrategia de acumulación y protección patrimonial para
            Directivos y Dueños de Negocio en México que buscan blindar su
            estilo de vida y el futuro de sus hijos.
          </h2>
        </motion.div>

        {/* Wistia Video Embed */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full max-w-4xl mx-auto rounded-xl md:rounded-2xl border border-gold/20 shadow-2xl overflow-hidden" data-id="element-78">
          <style dangerouslySetInnerHTML={{
          __html: `
                wistia-player[media-id='${WISTIA_VIDEO_ID}']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${WISTIA_VIDEO_ID}/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 56.25%;
                }
              `
        }} data-id="element-79" />
          <div dangerouslySetInnerHTML={{
          __html: `<wistia-player media-id="${WISTIA_VIDEO_ID}" aspect="1.7777777777777777"></wistia-player>`
        }} data-id="element-80" />
        </motion.div>

        {/* CTA below video — appears after 37 seconds */}
        <AnimatePresence data-id="element-81">
          {showVideoCTA && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 10
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="max-w-4xl mx-auto mt-5 md:mt-8 text-center" data-id="element-82">
              <motion.button onClick={() => {
            const el = document.getElementById('calendly-widget');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-navy font-bold text-base md:text-lg px-6 md:px-8 py-3.5 md:py-4 rounded-full shadow-[0_0_40px_rgba(201,168,76,0.3)] transition-colors" data-id="element-83">
                <CalendarIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-84" />
                AGENDA TU SESIÓN AQUÍ
              </motion.button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}